import BaseApiClient from '../BaseApiClient';
import { UserInterface } from '../../interfaces/User.interface';
import { CompanyInterface } from '../../interfaces/Company.interface';
import { featuresCedar } from '@interfaces/FeaturesCedar';

export class ApiUser extends BaseApiClient {
  /**
   * Gets current user
   */
  async me(): Promise<UserInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/me')
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async featuresEnabled(): Promise<featuresCedar[]> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/me/feature')
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Gets all users
   */
  async getAllUsers(keyword?: string): Promise<UserInterface[]> {
    return new Promise((resolve, reject) => {
      this.client
        .get(keyword ? `/api/v1/users?keyword=${keyword}` : '/api/v1/users')
        .then((res) => {
          if (res.data.data) {
            // The response is an array of objects with 'data' property
            const users = res.data.data.map((item: any) => item.data);
            resolve(users);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Gets current user company
   */
  async myCompany(): Promise<CompanyInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/company/tenant-parent')
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Updates User
   * @param data
   */
  async updateUserProfile(
    data: Partial<
      UserInterface & {
        profile_photo: File | null;
        current_password: string | null;
        password: string | null;
        password_confirmation: string | null;
      }
    >
  ): Promise<UserInterface> {
    return new Promise((resolve, reject) => {
      // TODO: Clean up so form data requests can be called directly from axios client
      const formData = new FormData();
      for (const [key, value] of Object.entries(data)) {
        formData.set(key, value as string | Blob);
      }
      this.client
        .post('/api/v1/update-user-profile', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { userQueryKeys } from './query-keys';
export {
  useUserFeaturesQuery,
  useUserMeQuery,
  useUserMyCompanyQuery,
  useUsersListQuery
} from './use-user-queries';
export {
  useUserUpdateProfileMutation,
  type UserUpdateProfileVariables
} from './use-user-mutations';

